package com.arena_web.data.repository

import com.arena_web.data.http.ApiResponse
import io.ktor.http.*

suspend fun <T> apiCall(block: suspend () -> ApiResponse<T>): Result<T> {
    return try {
        val response = block()
        if (response.data != null) {
            Result.success(response.data)
        } else if (response.errors.isNullOrEmpty() && response.code in 200..299) {
            // Successful response with empty body (e.g. 200/201/204 with no data)
            @Suppress("UNCHECKED_CAST")
            Result.success(Unit as T)
        } else {
            val errorMsg = response.errors?.joinToString() ?: "Request failed"
            Result.failure(Exception(errorMsg))
        }
    } catch (e: Exception) {
        Result.failure(e)
    }
}

suspend fun apiCallUnit(block: suspend () -> ApiResponse<Unit>): Result<Unit> {
    return try {
        val response = block()
        if (response.errors.isNullOrEmpty()) {
            Result.success(Unit)
        } else {
            Result.failure(Exception(response.errors.joinToString()))
        }
    } catch (e: Exception) {
        Result.failure(e)
    }
}

class HttpStatusException(val statusCode: HttpStatusCode) :
    Exception("Request failed: $statusCode")

suspend fun apiCallStatus(block: suspend () -> HttpStatusCode): Result<Unit> {
    return try {
        val status = block()
        if (status.isSuccess()) Result.success(Unit)
        else Result.failure(HttpStatusException(status))
    } catch (e: Exception) {
        Result.failure(e)
    }
}
